export type SelectedContact = {
  id: string;
  firstName: string;
  lastName: string;
  emailAddress?: string | null;
};
export const UNNAMED_LEARNER_CONTACT: SelectedContact = {
  id: "unnamed",
  firstName: "Unnamed",
  lastName: "Learner",
};
